/* eslint-disable no-plusplus */
export const getTeamNameByCode = (teamsByCode, teamCode) => {
  for (let i = 0; i < teamsByCode.length; i++) {
    if (teamsByCode[i].teamCode === teamCode) {
      return teamsByCode[i].name
    }
  }

  return null
}
